const breadcrumbsHome = { name: 'Home', pathName: '/home' }
const breadcrumbsHub = { name: 'Gerenciador de análises', pathName: null, action: 'gerenciador-analises' }
export default [
  {
    path: '/gerenciador-analises',
    component: () => import('@/modules/gerenciador-analises/views/pages/index.vue'),
    meta: {
      title: 'Gerenciador de análises',
      breadcrumbs: [breadcrumbsHome, breadcrumbsHub],
    },
    children: [],
  },
]
